import Vuetify from '@/plugins/vuetify';

export default {
  perguntas: [],
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    pergunta: '',
    resposta: '',
    codigoPessoa: '',
  },
  colunasPerguntas: [
    {
      field: 'pergunta',
      sortable: true,
      comparator: () => false,
      filter: 'TextFilter',
      filterParams: {
        module: 'perguntasRespostas',
        fetch: 'listarPerguntas',
        colDef: {
          field: 'pergunta',
        },
      },
      headerName: Vuetify.framework.lang.t('$vuetify.perguntas'),
      minWidth: 592,
    },
    {
      field: 'resposta',
      sortable: true,
      comparator: () => false,
      filter: 'TextFilter',
      filterParams: {
        module: 'perguntasRespostas',
        fetch: 'listarPerguntas',
        colDef: {
          field: 'resposta',
        },
      },
      headerName: Vuetify.framework.lang.t('$vuetify.respostas'),
      minWidth: 592,
    },
  ],
};
